import { ReactNode } from 'react';
import classNames from 'classnames';

interface Props {
  children?: ReactNode;
  className?: string;
}

export const StrongBrandContainer = ({ children, className }: Props) => (
  <strong className={classNames('u-color-brand', className)}>{children}</strong>
);
